<template>
  <v-container fluid pa-0 ma-0>
    <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  {{ title }}
                </h2>
              </template>
                <span>{{ title }}</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header">{{ subtitle }}</h4>
          </v-flex>         
        </v-layout>
      </div>
  </v-container>
</template>

<script>
export default {
  name: "PageHeader",
  data: () => ({}),
  props: {
    title: { type: String, default: "Welcome back" },
    subtitle: { type: String, default: "Your dashboard overview" }
  }
}
</script>
<style>

</style>
